import {HoistModel, LoadSpec, managed, TaskObserver, XH} from '@xh/hoist/core';
import {bindable, observableRef, runInAction} from '@xh/hoist/mobx';
import {RealEstateDeal} from '../../../data/DataTypes';
import {getDefaultOptions} from '../../../../core/ServiceUtils';
import {DealDialogModel} from './DealDialogModel';
import {CashFlowsDialogModel} from './CashFlowsDialogModel';

export class DealsModel extends HoistModel {
    apiTask = TaskObserver.trackLast();
    @observableRef accessor deals: RealEstateDeal[] = [];
    @managed dealEditModel = new DealDialogModel();
    @managed dealCfModel = new CashFlowsDialogModel();
    @bindable accessor searchText = '';

    constructor() {
        super();

        this.addReaction({
            track: () => this.searchText,
            run: () => this.refreshAsync()
        });
    }

    override async doLoadAsync(loadSpec: LoadSpec): Promise<void> {
        let deals = await this.fetchDealsAsync().linkTo(this.apiTask);

        if (this.searchText) {
            deals = deals.filter(
                d =>
                    d.name.toLowerCase().includes(this.searchText.toLowerCase()) ||
                    d.description.toLowerCase().includes(this.searchText.toLowerCase()) ||
                    d.sponsor.toLowerCase().includes(this.searchText.toLowerCase())
            );
        }

        runInAction(() => (this.deals = deals));
    }

    async addNew() {
        const deal = await this.dealEditModel.openAsync(null);
        if (deal != null) this.refreshAsync();
    }

    async edit(deal: RealEstateDeal) {
        deal = await this.dealEditModel.openAsync(deal);
        if (deal != null) this.refreshAsync();
    }

    getImageUrl(deal: RealEstateDeal): string {
        return `${XH.getConf('svcApiUrl')}/media/images/${deal.imageId}`;
    }

    showCashFlows(deal: RealEstateDeal) {
        this.dealCfModel.open(deal);
    }

    showDocuments(dea: RealEstateDeal) {}

    private fetchDealsAsync(): Promise<RealEstateDeal[]> {
        return XH.fetchService.getJson({
            url: `${XH.getConf('svcApiUrl')}/realestate/deals`,
            ...getDefaultOptions()
        });
    }
}
